export default __webpack_public_path__ + "static/media/drag-toolBox.23bf3988.svg";